;(function ($) {
    "use strict";

    $('.state-button').click(function (event) {
        var state = $('#state-select').val();
        var url = "/states/" + state;
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
        window.open(url, '_self');
    });

    $('.state-resource-button').click(function (event) {
        var stateResource = $('#state-resource-select').val();
        var urlResource = "/state-resource/" + stateResource;
        
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
        window.open(urlResource, '_self');
    });
    
})(jQuery);
